module.exports = __webpack_public_path__ + "img/48.c7887d44.jpg";